import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { BlogpostComponent } from "./components/blogpost/blogpost.component";
import { BlogpostsComponent } from "./components/blogposts/blogposts.component";

const routes: Routes = [
  { path: "blog", component: BlogpostsComponent },
  { path: "blog/:id", component: BlogpostComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BlogpostsRoutingModule {}
